import {createContext} from 'react';

// The value inside the createContext is default,
// which is used only when the Provider component don't pass any value (props) to the next component
const SkuQuotaMastersContext = createContext({
  fetchSkuQuotaMasters: () => {},
  fetchSkuQuotaMastersAll: () => {},
});

export default SkuQuotaMastersContext;
